import {Component, EventEmitter, Inject, OnInit, Output, input, ChangeDetectionStrategy} from '@angular/core';

import {Survey} from '@app/api/models/survey';

import {DATE_FORMAT} from '@app/api/constants';
import {DatePipe} from '@angular/common';
import {
  WaAvatarDirective, WaBadgeDirective,
  WaButtonDirective,
  WaCardDirective,
  WaIconDirective
} from "angular-awesome";
import {Dialog} from "@angular/cdk/dialog";

@Component({
    selector: 'app-survey-list-element',
    templateUrl: './survey-list-element.component.html',
    styleUrls: ['./survey-list-element.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [DatePipe, WaCardDirective, WaIconDirective, WaButtonDirective, WaAvatarDirective, WaBadgeDirective]
})
export class SurveyListElementComponent implements OnInit {

  readonly survey = input.required<Survey>();
  readonly selected = input<boolean>(false);
  readonly showAdminControls = input<boolean>(false);

  @Output() submitExclusionsEvent = new EventEmitter<Survey>();
  @Output() editSurveyEvent = new EventEmitter<Survey>();
  @Output() publishSurveyEvent = new EventEmitter<Survey>();
  @Output() editAssignmentsEvent = new EventEmitter<Survey>();
  @Output() removeSurveyEvent = new EventEmitter<Survey>();
  @Output() optimizationDashboardEvent = new EventEmitter<Survey>();

  tooltipText: string = '';
  statusIcon: string = '';
  voting_upcoming = false
  voting_ongoing = false
  voting_ended = false

  constructor(@Inject(DATE_FORMAT) public dateFormat: string, dialog: Dialog) {}

  ngOnInit(): void {
    const now = new Date;
    now.setHours(0,0,0,0)     // otherwise "now" is today's date at the current time
    const begin = new Date(this.survey().begin);
    const end = new Date(this.survey().end);

    console.log("Date today "+now)
    console.log("Date begin "+begin)
    console.log("Date end "+end)

    if (begin <= now && now <= end) {
      this.voting_ongoing = true;
      this.voting_upcoming = false;
      this.voting_ended = false
      this.statusIcon = 'update';
      this.tooltipText = 'Pending';

    } else if (begin > now) {
      this.voting_ongoing = false;
      this.voting_upcoming = true;
      this.voting_ended = false
      this.statusIcon = 'event_upcoming';
      this.tooltipText = 'Upcoming';

    } else {
      this.voting_ongoing = false;
      this.voting_upcoming = false;
      this.voting_ended = true
      this.statusIcon = 'assignment_turned_in';
      this.tooltipText = 'Voting has ended';
    }
  }
}
